import React, { useState } from "react";
import "../assets/styles/editor.css";

export const SelectedTimeFrame = ({
  selectedLabelTab,
  timing1,
  n,
  updateProgress,
  getTimeandFrame,
  scrollBarRef,
  frameCount,
  frameTimeLimit,
  sublabelTimings,
  currentVideoPlayTime
}) => {
  const [visibleItem, setVisibleItem] = useState(0);
  selectedLabelTab.frameLabel.start = parseFloat(
    selectedLabelTab.frameLabel.start
  );
  selectedLabelTab.frameLabel.end = parseFloat(selectedLabelTab.frameLabel.end);
  let [visibleNNodes, setVisibleNodes] = useState(
    Math.floor((window.screen.availWidth * 0.74) / 5)
  );
  let selectedLablMaxFram = Math.floor(
    (selectedLabelTab.frameLabel.end - selectedLabelTab.frameLabel.start) / frameTimeLimit
  );
  const onchangeScroll = (e) => {
    setVisibleNodes(
      Math.floor((window.screen.availWidth * 0.74 + e.target.scrollLeft) / 5)
    );
  };
  const handleClickOnTimeLine = (secnd, selectedLabelTab) => {
    let isvaluesAvailable = false;
    sublabelTimings.map((sublabel, index) => {
      sublabel.timings.map((item, index1) => {
        if (item?.start != undefined && item?.end != undefined) {
          isvaluesAvailable = true
        }
      })
    })
    if (isvaluesAvailable) {
      updateProgress({
        type: "frames",
        time: secnd,
        ...selectedLabelTab,
      })
    }
  }
  return (
    <div
      className='playback_timer play_back_timer_frame_control'
      style={{ width: window.screen.availWidth * 0.74, paddingTop: "18px" }}
      onScrollCapture={(e) =>
        visibleNNodes < selectedLablMaxFram && onchangeScroll(e)
      }
      ref={scrollBarRef}
    >
      <div
        className='seekable_time seekableTimeFrame'
        style={{
          width: window.screen.availWidth * 0.74
        }}
      ></div>
      <div className='timingcontainer frameTimingContainer'>
{timing1 && selectedLabelTab?.frameLabel && (function () {
  const frameTimeLimit = 0.04;
  const frameIndex = Math.round(currentVideoPlayTime / frameTimeLimit);
  const displayFrames = [];

  for (let index = frameIndex - 10; index <= frameIndex + 10; index++) {
    if (index < 0 || index >= timing1.length) continue;

    const item = timing1[index];
    const secnd = parseFloat((index * frameTimeLimit).toFixed(10));

    if (secnd >= currentVideoPlayTime-(frameTimeLimit*10) && secnd <= currentVideoPlayTime+(frameTimeLimit*10)) {
      displayFrames.push(
        <div
          onMouseEnter={function () { setVisibleItem(item); }}
          onClick={function () { handleClickOnTimeLine(secnd, selectedLabelTab); }}
          className="seconsTimelineFrames"
          key={"timing_seconds_List" + index}
        >
          {((1 / frameTimeLimit) % 1) !== 0 ? (
            <>
              {index % frameCount === 0 ? (
                <p
                  className="secondmeasurement"
                  style={{
                    fontWeight: "1000",
                    fontSize: "21px",
                    marginTop: "-11px",
                  }}
                >
                  <sub>|</sub>
                </p>
              ) : (
                <p className="secondmeasurement">|</p>
              )}
              {index % frameCount === 0 && (
                <p className="secondsDisplay hmsparagraph">
                  {getTimeandFrame(secnd)}
                </p>
              )}
              {index % frameCount !== 0 && item === visibleItem && (
                <p className={`secondsDisplayonHover ${index==frameIndex + 10 && "secondsHoverLast"}`}>
                  {getTimeandFrame(secnd)}
                </p>
              )}
            </>
          ) : (
            <>
              {index % frameCount === 0 ? (
                <p
                  className="secondmeasurement"
                  style={{
                    fontWeight: "1000",
                    fontSize: "21px",
                    marginTop: "-11px",
                  }}
                >
                  <sub>|</sub>
                </p>
              ) : (
                <p className="secondmeasurement">|</p>
              )}
              {index % frameCount === 0 && (
                <p className="secondsDisplay hmsparagraph">
                  {getTimeandFrame(secnd)}
                </p>
              )}
              {index % frameCount !== 0 && item === visibleItem && (
                <p className={`secondsDisplayonHover ${index==frameIndex + 10  && "secondsHoverLast"}`}>
                  {getTimeandFrame(secnd)}
                </p>
              )}
            </>
          )}
        </div>
      );
    }
  }

  return displayFrames;
})()}

      </div>
    </div>
  );
};
